export default __webpack_public_path__ + "static/media/CookiesMonster.e3bc1e2e.png";